import NewsletterForm from "../components/NewsletterForm";
import { useI18n } from "../lib/i18n";
import { useCText } from "../lib/cms";
import { useSEO } from "../lib/seo";

export default function Newsletter() {
  const { t } = useI18n();
  const intro = useCText("newsletter.intro", "newsletter.intro");

  useSEO({
    title: "Newsletter · Maggie Records",
    description: "Recibe avisos de novedades y recomendaciones de Maggie Records. Un email cada dos semanas. Nada más.",
  });

  return (
    <div className="max-w-[1100px] mx-auto px-5 md:px-10 pt-10 md:pt-14 pb-20" data-testid="newsletter-page">
      <div className="border-b border-border pb-6 md:pb-8 mb-10 md:mb-14">
        <p className="text-xs text-muted-foreground mb-2">{t("nav.subscribe")}</p>
        <h1 className="text-3xl md:text-5xl font-medium leading-tight">
          {t("newsletter.title")}
        </h1>
        <p className="text-sm text-muted-foreground mt-5 max-w-xl leading-relaxed">
          {intro}
        </p>
      </div>

      <div className="max-w-md">
        <NewsletterForm />
        <p className="text-xs text-muted-foreground mt-5 leading-relaxed">
          Un email cada dos semanas con novedades y recomendaciones. Nada más. Puedes darte de baja cuando quieras desde cualquier correo.
        </p>
      </div>
    </div>
  );
}
